/* eslint-disable react-hooks/exhaustive-deps */
import {LocationDescriptorObject} from 'history'
import NProgress from 'nprogress'
import {parse} from 'query-string'
import React, {useEffect, useRef, useState} from 'react'
import {Route, withRouter} from 'react-router-dom'

import {fetchDataBeforeRender} from '~/utils/fetchDataBeforeRender'

import 'nprogress/nprogress.css'

function equalStr(location: LocationDescriptorObject) {
  const {key, ...rest} = location || {}
  return JSON.stringify(rest)
}

function PendingNavDataLoader({location, routes, store, children}) {
  const initRef = useRef(false)
  const [nextLocation, setNextLocation] = useState(location)

  useEffect(() => {
    if (!initRef.current) {
      // 首次来此server 不重复获取数据
      initRef.current = true
      return
    }
    fetchDataBeforeRender({
      store,
      routes,
      query: parse(location.search),
      url: location.pathname,
      onProgress: ({progress}) => {
        NProgress.set(progress)
      },
    }).then(() => {
      setNextLocation(location)
    })
  }, [equalStr(location)])

  return <Route location={nextLocation} render={children} />
}

export default withRouter<any, any>(PendingNavDataLoader)
